import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("ajax:success", (event) => {
      const xhr = event.detail[2];
      document.body.insertAdjacentHTML("afterbegin", xhr.responseText);

      $("#new-transaction-item-modal").modal("show");
      $("#transaction_item_shipment_id").select2();
      $("#transaction_item_service_item_id").select2();
    });
  }
}
